import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconUserShield: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18.9589C9.93333 18.9589 9.86662 18.948 9.80245 18.9263C8.47828 18.4847 1.875 15.9355 1.875 9.07383V4.16721C1.875 3.86971 2.08502 3.61212 2.37752 3.55462C6.44419 2.74129 7.88588 2.02637 9.71171 1.12054C9.88838 1.03304 10.1216 1.02144 10.2966 1.10894C12.0958 2.01644 13.5175 2.73295 17.6233 3.55462C17.9158 3.61295 18.1258 3.86971 18.1258 4.16721V9.07464C18.1258 15.9363 11.5225 18.4855 10.1984 18.9271C10.1334 18.948 10.0667 18.9589 10 18.9589ZM3.125 4.67726V9.07383C3.125 14.7947 8.47333 17.1239 10 17.6714C11.5267 17.1239 16.875 14.7938 16.875 9.07383V4.67726C13.1892 3.90559 11.6399 3.18295 10.0124 2.36545C8.28158 3.22129 6.77917 3.91393 3.125 4.67726ZM10.0051 10.0423C8.90259 10.0423 8.00578 9.14463 8.00578 8.04213C8.00578 6.93963 8.90259 6.04221 10.0051 6.04221C11.1076 6.04221 12.005 6.93963 12.005 8.04213C12.005 9.14463 11.1076 10.0423 10.0051 10.0423ZM10.0051 7.29221C9.59175 7.29221 9.25578 7.6288 9.25578 8.04213C9.25578 8.45546 9.59175 8.79225 10.0051 8.79225C10.4184 8.79225 10.755 8.45546 10.755 8.04213C10.755 7.6288 10.4184 7.29221 10.0051 7.29221ZM12.5 13.9589C12.155 13.9589 11.875 13.6789 11.875 13.3339V13.0814C11.875 12.4814 11.4609 11.8755 10.5351 11.8755H9.46574C8.53991 11.8755 8.12581 12.4814 8.12581 13.0814V13.3339C8.12581 13.6789 7.84581 13.9589 7.50081 13.9589C7.15581 13.9589 6.87581 13.6789 6.87581 13.3339V13.0814C6.87581 11.8614 7.76491 10.6255 9.46574 10.6255H10.5351C12.2359 10.6255 13.125 11.8606 13.125 13.0814V13.3339C13.125 13.6789 12.845 13.9589 12.5 13.9589Z"
      fill={color}
    />
  </svg>
);

export default IconUserShield;
